import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import PrimaryButton from "../components/PrimaryButton";
import axiosInstance from '../axiosConfig';
import { useNavigate } from "react-router-dom";
import { formatValue } from "../utils/formatValue";
import { formatTelefone } from "../utils/formatTelefone";
import { handleError } from "../services/handleError";
import Loading from "./Loading";

function HistoricoPedidos() {
    const [pedidos, setPedidos] = useState([]);
    const navigate = useNavigate();
    const [expandedRow, setExpandedRow] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleRowClick = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    useEffect(() => {
        buscarPedidos();
    }, []);

    async function buscarPedidos() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Pedidos/Pedidos");

            setPedidos(response.data);
        } catch (error) {
            handleError(error, "Erro ao buscar pedidos.");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <div className="p-5 text-black">
                <div className="mb-3">
                    <div className="flex flex-wrap justify-between">
                        <div className="flex items-center">
                            <PrimaryButton onClick={() => navigate('/pedidos')}>
                                <FontAwesomeIcon icon={faHistory} className="mr-2" />
                                Pedidos em Aberto
                            </PrimaryButton>
                        </div>
                    </div>
                </div>

                <div className="overflow-x-auto bg-white shadow-md rounded-lg">
                    <table className="min-w-full table-auto">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Data</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Número</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Modalidade</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Status</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Valor Total</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Cliente</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Telefone</th>
                                <th className="px-2 sm:px-4 py-2 whitespace-nowrap">Detalhes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pedidos.map((pedido) => (
                                <>
                                    <tr key={pedido.id} className="border-b text-center">
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{new Date(pedido.dtCriacao).toLocaleDateString("pt-BR")}{" "}{new Date(pedido.dtCriacao).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{pedido.id.toString().padStart(6, '0')}#</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{pedido.tipoEntrega}</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{pedido.status}</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{formatValue(pedido.valorTotal)}</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{pedido.cliente?.nome !== "" ? pedido.cliente?.nome : "Mesa " + pedido.numeroMesa}</td>
                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">{pedido.cliente?.telefone ? formatTelefone(pedido.cliente?.telefone) : "Mesa " + pedido.numeroMesa}</td>

                                        <td className="px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-md whitespace-nowrap">
                                            <button
                                                className="text-blue-500 hover:text-blue-700"
                                                onClick={() => handleRowClick(pedido.id)}
                                            >
                                                {expandedRow === pedido.id ? "Ocultar" : "Detalhes"}
                                            </button>
                                        </td>
                                    </tr>
                                    {expandedRow === pedido.id && (
                                        <tr className="bg-gray-50 transition-all duration-300 ease-in-out">
                                            {pedido.tipoEntrega === "Delivery" &&
                                                <td colSpan="4" className="p-4 border-t align-top">
                                                    <div className="text-center font-semibold text-gray-700">📍 Dados de Entrega</div>
                                                    <div className="mt-2 text-sm text-gray-600 space-y-1">
                                                        <p><strong>Nome:</strong> {pedido.cliente?.nome}</p>
                                                        <p><strong>Endereço:</strong> {pedido.cliente?.logradouro} Nº {pedido.cliente?.numero} - {pedido.cliente?.bairro}, {pedido.cliente?.cidade} - {pedido.cliente?.estado}</p>
                                                        <p><strong>Telefone:</strong> {formatTelefone(pedido.cliente?.telefone)}</p>
                                                        <p><strong>Forma de Pagamento:</strong> {pedido.formaPagamento}</p>
                                                    </div>
                                                </td>
                                            }

                                            <td colSpan={pedido.tipoEntrega === "Delivery" ? 4 : 8} className="p-4 border-t align-top">
                                                <div className="text-center font-semibold text-gray-700">🛒 Produtos</div>
                                                <div className="mt-2 text-sm text-gray-600 space-y-3">
                                                    {pedido.itensPedido.map((produto) => (
                                                        <div className="border-b pb-2">
                                                            <p>
                                                                <strong>{produto.quantidade}{produto.produto?.porKg ? "kg" : "x"}</strong> {produto.produto?.titulo} -
                                                                <span className="text-green-700 font-semibold"> {formatValue(produto.valorTotal)}</span>
                                                            </p>
                                                            {produto.observacao && <p className="text-xs text-gray-500">Observação: {produto.observacao}</p>}
                                                            <p className="text-xs text-gray-500">
                                                                {produto.listAdicionais
                                                                    .map((item, index) => (
                                                                        <p key={item.id} className="text-xs text-gray-500">
                                                                            {index === 0 ? "Adicionais: " : ""} + {item.nome} {item.valorExtra > 0 && `(+ ${formatValue(item.valorExtra)})`}
                                                                        </p>
                                                                    ))}
                                                            </p>
                                                            {produto.listPerguntas.length > 0 && (
                                                                <div className="text-xs text-gray-500">
                                                                    {produto.listPerguntas.map((pergunta, index) => (
                                                                        <p key={index}>
                                                                            {index === 0 ? "Escolhas: " : ""} - {pergunta.textoPergunta}: {pergunta.textoOpcao}
                                                                            {pergunta.valorExtra > 0 && ` (+ ${formatValue(pergunta.valorExtra)})`}
                                                                        </p>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                    <div className="mt-2 font-semibold text-gray-800 text-right">
                                                        Total: <span className="text-green-700 text-lg">{formatValue(pedido.valorTotal)}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default HistoricoPedidos;